<template>
    <div class="nk-aside" data-content="sideNav" data-toggle-overlay="true" data-toggle-screen="lg"
        data-toggle-body="true" style="padding-left: 1.3rem;">
        <div class="nk-sidebar-menu" data-simplebar>

            <ul class="nk-menu" v-if="ldata!=null && ldata.type==='user'">
              
                <li class="nk-menu-item">
                    <a href="/" id="m1" @click="set_menu(1)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                dashboard
                            </span>
                        </span>
                        <span class="nk-menu-text">Dashboard</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/booking_pages" id="m2" @click="set_menu(2)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                event_available
                            </span>
                        </span>
                        <span class="nk-menu-text">Booking Pages</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/bookings" id="m2" @click="set_menu(2)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                event_available
                            </span>
                        </span>
                        <span class="nk-menu-text">Bookings</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/calender1"  id="m3" @click="set_menu(3)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                calendar_today
                            </span>
                        </span>
                        <span class="nk-menu-text">Calendar</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/todo" id="m4" @click="set_menu(4)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                checklist
                            </span>
                        </span>
                        <span class="nk-menu-text">To-Do</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/templetes" id="m5" @click="set_menu(5)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                description
                            </span>
                        </span>
                        <span class="nk-menu-text">Routing Forms</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/email_templetes" id="m5" @click="set_menu(5)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                mail
                            </span>
                        </span>
                        <span class="nk-menu-text">Email Settings</span>
                    </a>
                </li>
                
                <li class="nk-menu-item">
                    <a href="/packages" id="m5" @click="set_menu(5)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                category
                            </span>
                        </span>
                        <span class="nk-menu-text">Packages</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/ai_reports" id="m6" @click="set_menu(6)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                bar_chart
                            </span>
                        </span>
                        <span class="nk-menu-text">AI Reports</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="/settings" id="m7" @click="set_menu(7)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                settings
                            </span>
                        </span>
                        <span class="nk-menu-text">Settings</span>
                    </a>
                </li>
                <li class="nk-menu-item">
                    <a href="javascript:void(0)" data-bs-toggle="modal" style="border-radius: 0.6rem;"
                    data-bs-target="#logoutForm"  class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 200;">
                                logout
                            </span>
                        </span>
                        <span class="nk-menu-text">Logout</span>
                    </a>
                </li>
            </ul>
            <ul class="nk-menu" v-if="ldata!=null && ldata.type==='admin'">
  
                <li class="nk-menu-item">
                    <a href="/" id="m1" @click="set_menu(1)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 300;">
                                space_dashboard
                            </span>
                        </span>
                        <span class="nk-menu-text">Dashboard</span>
                    </a>
                </li>

                <li class="nk-menu-item">
                    <a href="/all_users" id="m2" @click="set_menu(2)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 300;">
                                group
                            </span>
                        </span>
                        <span class="nk-menu-text">All Customers</span>
                    </a>
                </li>

                <li class="nk-menu-item">
                    <a href="/subscribers" id="m2" @click="set_menu(2)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 300;">
                                person_add
                            </span>
                        </span>
                        <span class="nk-menu-text">Subscribers</span>
                    </a>
                </li>

                <li class="nk-menu-item">
                    <a href="/mem_plans" id="m3" @click="set_menu(3)" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 300;">
                                credit_card
                            </span>
                        </span>
                        <span class="nk-menu-text">Subscription Plans</span>
                    </a>
                </li>

                <li class="nk-menu-item">
                    <a href="javascript:void(0)" data-bs-toggle="modal" style="border-radius: 0.6rem;"
                    data-bs-target="#logoutForm" class="nk-menu-link">
                        <span class="nk-menu-icon">
                            <span class="material-symbols-outlined" style="font-variation-settings: 'wght' 300;">
                                logout
                            </span>
                        </span>
                        <span class="nk-menu-text">Logout</span>
                    </a>
                </li>
            </ul>

        </div>
        <div class="nk-aside-close"><a href="#" class="toggle" data-target="sideNav"><em
                    class="icon ni ni-cross"></em></a></div>
    </div>
    <div class="modal fade" id="logoutForm">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="border-radius:1rem;">
            <div class="modal-header">
                <h6 class="modal-title">Logout</h6>
            </div>
            <div class="modal-body">
                <div class="form-validate is-alter">
                   <p>Are you sure, you want to logout?</p>
                    <div class="form-group">
                        <button type="button" @click="logoutNow()" class="btn btn-success" style="border-radius: 0.6rem;">
                            Yes
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" data-bs-dismiss="modal"
                        aria-label="Close" class="btn btn-outline-success" style="border-radius: 0.6rem;">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mainBaseUrl } from '@/apis/appconst';
export default {
    name: 'MainMenu',
    methods: {
        set_menu($pos) {
            
            this.menu_pos = $pos;
            for(var x=0;x<6;x++){
                if(this.menu_pos==x){
                    document.getElementById("m"+(x+1)).className = "nk-menu-link active";
                }
                else{
                    document.getElementById("m"+(x+1)).className = "nk-menu-link";
                }
            }
        }
        ,
        logoutNow(){
            sessionStorage.clear();
            window.location.reload();
        }
        
    },
    data() {
        return {
            base_url: "",
            menu_pos: 3,
            ldata:null
        };
    },
    mounted() {
        if (sessionStorage.getItem("ldata") && sessionStorage.getItem("ldata").length > 0) {
            this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
        }
        this.base_url = mainBaseUrl;
        const lastSegment = window.location.pathname.split('/').filter(Boolean).pop();
        if(lastSegment.localeCompare("bookings")==0){
            this.set_menu(2);
        }
        else if(lastSegment.localeCompare("calender1")==0){
            this.set_menu(3);
        }
        else if(lastSegment.localeCompare("todo")==0){
            this.set_menu(4);
        }
        else if(lastSegment.localeCompare("templetes")==0){
            this.set_menu(5);
        }
        else if(lastSegment.localeCompare("ai_reports")==0){
            this.set_menu(6);
        }
        else if(lastSegment.localeCompare("settings")==0){
            this.set_menu(7);
        }
        else {
            this.set_menu(1);
        }
    },
}
</script>

<style>
 a:hover {
          color: black;
        }
</style>

